import { render, staticRenderFns } from "./AllOtherIncomeTable.vue?vue&type=template&id=3224c1ce"
import script from "./AllOtherIncomeTable.vue?vue&type=script&lang=js"
export * from "./AllOtherIncomeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports